import React from "react";
import { Container, Col, Row, Image } from "react-bootstrap";
import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import "../../../Assets/css/mjstatic.css";
import Button from "@mui/material/Button";
import OwnerImage from "../../../Assets/images/static/Malak_0008.webp";
import StoreImage from "../../../Assets/images/static/Rings_0012.webp";
import StoreImage1 from "../../../Assets/images/static/MJ-1.webp";
import { Helmet } from "react-helmet";
import aboutimg from "../../../Assets/images/static/demo/img-about2.jpg";
import { useSelector } from "react-redux";
import { client_name, contact_number } from "../../../Helpers/request";

const OurStory = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <div className="rcs_ringsetting_section mt-3">
        <Container>
          <Row>
            <Col className="rcs_breadcrumb m-0 mb-md-5">
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/">
                  Home
                </Link>
                <Typography color="text.primary">About Us</Typography>
              </Breadcrumbs>
            </Col>
          </Row>
          <Row className="m-auto w-100">
            <div className="rcs_story_content">
              <h2>About Us</h2>
              <p>
                {/* {client_name.c_name} */}
                 We are a globally trusted purveyor of personalised, affordable and high-quality diamonds and jewellery. Our collection is sold in London.
              </p>
              <h3>Exceptional Diamond Jewellery At Affordable Prices</h3>
              <p>
              We are renowned for providing exceptional diamond jewellery at affordable prices. Combined with our first-class Customer Care Team, it’s easy to see why over 5,000 happy customers have chosen to buy their diamond jewellery from us.
              </p>
              <h3>Mission</h3> 
              <p>
              With more than 5,000 happy customers, our diamond jewellery is sold in London. Whilst this would be sufficient for most companies, our mission is to be regarded as ‘the most trusted purveyor of personalised, affordable and high-quality diamonds and jewellery in the world’.
              </p>
              <p>We’re confident that we’ll achieve our mission by staying true to the 3 principles as given below</p>
              <h3>Personalised</h3>
              <p>Unique, original and perfectly matched to suit your tastes, our personalisation service is perfect for that special person in your life. After all, your choice of jewellery is a direct mirror of your personal tastes, attitude and character.</p>
              <p>Personalised diamond jewellery is where the Heart of Diamond excels; we are well-known around the London as the premier diamond jewellers that offer a range of beautiful jewellery that can be personalised to suit your personality. You’ll see a range of diamond jewellery (Engagement Rings, wedding Rings & Wedding Bands, Diamond Rings) here on our website. However, if you would prefer, we can create a truly bespoke piece (bespoke engagement ring), using your very own design ideas, making the most intimate and perfect gift possible.</p>
              <h3>Superb Value</h3>
              <p>Superb value is what sets us apart from the hyper-inflated prices you’ll find on the high street and on the web.</p>
              <p><b>3 reasons why we can provide superb value</b></p>
              <ul>
    <li>We are a diamond manufacturer, so we don’t have to deal with all the middlemen, taking their cut.</li>
    <li>We do not have costly high-street stores.</li>
    <li>We run our operations incredibly efficiently, so we only use resources when we need them. </li>

              </ul>
              <p><b>Please Note</b></p>
              <p>Value doesn’t mean poor quality. All our jewellery is crafted by expert master jewellers using the most beautiful and ethically sourced diamonds.</p>
              
            </div>
          </Row>

          <div className="rcs_story_content mt-5 mb-5">
            <Row className=" w-100">
              <Col md={6} xs={12} >
              <h3>Quality Materials Sourced Ethically</h3>
              <p>You can only create a high-quality piece of jewellery by using quality materials. With regards to the quality of our diamonds and the precious metals we use, we strive for the highest quality jewellery in everything we do.</p>
              <p>In terms of the ethical side of our business, we work with all of the leading diamond and jewellery institutions in the world. Institutions including The British Jewellers’ Association, Assay Assured &amp London Assay Office for metal, Stop Blood Diamonds membership, The Gemological Institute of America, International Gemological Institute and The World Diamond Council.</p>
              <p>As a globally trusted purveyor of diamonds, you can be sure that our diamonds are also of exceptional quality. You can of course choose which type of quality you’d prefer, should you wish to customise your jewellery.</p>
           
              </Col>
              <Col md={6} xs={12}>
                <div className="rcs_our_story_img_main">
                  <Image src={aboutimg} alt="about us image"></Image>
                </div>
              </Col>
              <Col md={12} xs={12} className="mt-5"> 
              <h2>Get In Touch</h2>
                <p>
                If you would like to discuss how we can provide such superb value across our entire diamond jewellery collection, please contact our friendly Customer Care Team on  <b className="nomber"><span
                          onClick={(e) => {
                            window.location.href = contact_number.link;
                          }}
                        >
                        
                         {contact_number.text}
                        </span>
                        </b>
                </p>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default OurStory;
